class FetchGrantedUsers {
	constructor(
		public readonly accountId: number,
		public readonly ids: readonly number[],
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const params = new URLSearchParams();

		for (const id of this.ids) {
			params.append('id', String(id));
		}

		params.set('rows', '200');

		return params.toString();
	}
}

export default FetchGrantedUsers;
